import {
  IHospitalScheduleTemplateModel,
  IVeterinarianModel,
  VeterinarianModel,
} from '@common/models';
import { defaultTo } from 'lodash';
import { HospitalScheduleTemplateModel } from './HospitalScheduleTemplateModel';
import {
  HospitalScheduleRequestModel,
  IHospitalScheduleRequestModel,
} from './requests/HospitalScheduleRequestModel';

export interface IHospitalScheduleModel extends IHospitalScheduleRequestModel {
  veterinarian: IVeterinarianModel | undefined;
  scheduleTemplate: IHospitalScheduleTemplateModel | undefined;
  isAdhoc: boolean;
}

export class HospitalScheduleModel
  extends HospitalScheduleRequestModel
  implements IHospitalScheduleModel
{
  veterinarian: VeterinarianModel | undefined;
  scheduleTemplate: HospitalScheduleTemplateModel | undefined;
  isAdhoc: boolean;

  constructor(params?: Partial<IHospitalScheduleModel>) {
    super(params);
    this.veterinarian = params?.veterinarian
      ? new VeterinarianModel(params.veterinarian!)
      : undefined;
    this.scheduleTemplate = params?.scheduleTemplate
      ? new HospitalScheduleTemplateModel(params.scheduleTemplate!)
      : undefined;
    this.isAdhoc = defaultTo(params?.isAdhoc, false);
  }
}
